/** @jsx jsx */
import { jsx } from "theme-ui"
import { graphql, useStaticQuery } from "gatsby"
import SectionWrapper from "./section-wrapper"
import SectionHeader from "./section-header"
import WorkCard from "./work-card"
import WorkTechnologies from "./work-technologies"
import WorkCTA from "./work-cta"
import WorkTestimonial from "./work-testimonial"
import { rain, darkRain } from "./patterns"

const WorkSection = () => {
  const data = useStaticQuery(graphql`
    {
      projectImage1: file(relativePath: { eq: "fast-museum.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 900, layout: CONSTRAINED)
        }
      }
      projectImage2: file(relativePath: { eq: "fast-museum.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 900, layout: CONSTRAINED)
        }
      }
      projectImage3: file(relativePath: { eq: "facebook-banner.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 900, layout: CONSTRAINED)
        }
      }
    }
  `)
  return (
    <SectionWrapper
      id="work"
      bg="secondary"
      pattern={rain}
      darkpattern={darkRain}
    >
      <SectionHeader>Useful Links</SectionHeader>
      <div
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gridTemplateRows: "auto",
          gridGap: 4,
          maxWidth: "maxPageWidth",
          margin: "0 auto",
          pt: 5,
        }}
      >
        <WorkCard
          link="https://www.airsciences.org.uk/"
          image={data.projectImage2.childImageSharp.gatsbyImageData}
          title="Farnborough Air Sciences Trust"
          description="The museum is dedicated to Farnborough's proud aviation heritage and significant contribution to air science and research, and offers an important educational resource as well as an entertaining and stimulating day out for anyone interested in aviation history and scientific progress."
        />
        <WorkCard
          link="https://www.rushmoor.gov.uk/"
          image={data.projectImage1.childImageSharp.gatsbyImageData}
          title="Rushmoor Borough Council"
          description="The official Rushmoor Borough Council website carries a lot of information and if you are looking to find details regarding amenities, this is the place to go"
        />
        <WorkCard
          link="https://www.facebook.com/HeartOfFrn"
          image={data.projectImage3.childImageSharp.gatsbyImageData}
          title="Our Facebook Page"
          description="Our Facebook page is always active and is well worth following if you want to stay in the loop with what is going on around the town"
        />
      </div>
      {/* <div sx={{ display: "grid", placeItems: "center", my: 4 }}>
        <WorkTestimonial />
      </div> */}
      {/* <WorkCTA /> */}
      {/* <WorkTechnologies /> */}
    </SectionWrapper>
  )
}
export default WorkSection
